import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1E3C72",
      },
      dark: {
        primary: "#1E3C72",
      },
    },
  },
});
